import { Product as ProtoProduct } from '@italist/grpc-proto/entities/product_pb';
import { SearchPrice } from '@italist/grpc-proto/entities/search_pb';

import { formatPrice } from 'helpers/stringFormatters';
import { Product } from 'models/product';
import { isSearchProduct, SearchResult } from 'models/search';

const getPriceExtracted = (
  priceList: ProtoProduct.Price.AsObject[],
  currency: string,
): ProtoProduct.Price.AsObject | null => {
  const finding = priceList.find(priceEntry => priceEntry.currency === currency);
  return finding || null;
};

const getSearchPriceExtracted = (priceList: SearchPrice.AsObject[], currency: string): SearchPrice.AsObject | null => {
  const finding = priceList.find(priceEntry => priceEntry.currency === currency);
  return finding || null;
};

export const getPrices = ({
  approxCurrencyCode,
  currencySymbol,
  product,
}: {
  approxCurrencyCode: string;
  currencySymbol: string;
  product: Product | SearchResult;
}) => {
  if (isSearchProduct(product)) {
    const { discountPercentage: rp, price, priceInAlternativeCurrenciesList } = product;
    const reductionPercentage = rp;
    const approxPrice =
      approxCurrencyCode && getSearchPriceExtracted(priceInAlternativeCurrenciesList, approxCurrencyCode);

    const formattedPriceApprox = formatPrice(approxPrice?.salePrice, approxCurrencyCode);
    const formattedPriceBaseAfterTax = formatPrice(price.price, currencySymbol);
    const formattedPriceReducedAfterTax = formatPrice(price.salePrice, currencySymbol);
    return { formattedPriceApprox, formattedPriceBaseAfterTax, formattedPriceReducedAfterTax, reductionPercentage };
  }

  const {
    price,
    price: { reductionPercentage },
    priceInAlternativeCurrenciesList,
  } = product as Product;
  const approxPrice = approxCurrencyCode && getPriceExtracted(priceInAlternativeCurrenciesList, approxCurrencyCode);

  const formattedPriceApprox = formatPrice(approxPrice.reducedAfterTax, approxCurrencyCode);
  const formattedPriceBaseAfterTax = formatPrice(price.baseAfterTax, currencySymbol);
  const formattedPriceReducedAfterTax = formatPrice(price.reducedAfterTax, currencySymbol);

  return { formattedPriceApprox, formattedPriceBaseAfterTax, formattedPriceReducedAfterTax, reductionPercentage };
};
